<template>
  <div class="kalem">
    <resultDialog ref="showMessage"></resultDialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-card flat>
      <v-layout row wrap>
        <v-flex xs12 pr-2 md9 sm9>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-tabs
                slot="extension"
                color="grey lighten-4"
                v-model="tabmodel"
              >
                <v-menu bottom right offset-y>
                  <v-btn slot="activator" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="(item, i) in menuItems"
                      :key="i"
                      @click="menuClick(i)"
                    >
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-tab :href="`#tab-genel`">{{ $t('tab_general') }} </v-tab>
                <v-tab :href="`#tab-ozel`"> {{ $t('Private-Information')}} </v-tab>
                <v-tab :href="`#tab-maliyet`">{{$t('Cost')}}</v-tab>
                <v-tab :href="`#tab-komisyon`">{{ $t("Commission") }}</v-tab>
                <v-tab :href="`#tab-aciklama`">{{ $t('Description') }}</v-tab>
                <v-tab :href="`#tab-diger`">{{ $t('Other') }}</v-tab>
              </v-tabs>
            </v-flex>

            <v-flex xs12 sm12>
              <v-tabs-items v-model="tabmodel">
                <v-tab-item :id="`tab-genel`">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat color="grey lighten-5">
                        <v-layout row wrap>
                          <v-flex xs5 sm5 md5>
                            <v-layout row wrap>
                              <v-flex pl-1 xs11 sm11 md11>
                                <cariaracomp
                              v-bind:etiket="$t('Current')"
                              v-bind:value="val.kalem.cariKod.kod"
                              v-model="val.kalem.cariKod.kod"
                              :Coper="true"
                            ></cariaracomp>

                              </v-flex>
                             
                              <v-flex pl-1 xs11 sm11 md11>
                              
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  :tip="val.kalem.saticiTip"
                                  :label="$t('Seller-Code')"
                                  v-model="val.kalem.satici"
                                ></genelarama>
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="val.kalem.satici"
                                    :label="'Otel Ekle'"
                                    :saticiKod="val.kalem.saticiTip"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <genelarama
                                  apiname="SaticiAra"
                                  :tip="12"
                                  :label="$t('Tour-Operator')"
                                  v-model="val.kalem.turOperatoru"
                                ></genelarama>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <tarihcomp
                                        :etiket="$t('Term-Start')"
                                        v-bind:detaygizle="true"
                                        v-bind:defaultvalue="'ok'"
                                        v-bind:value="val.kalem.donem1"
                                        @input="startDateChange()"
                                        v-model="val.kalem.donem1"
                                      ></tarihcomp>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <tarihcomp
                                        :etiket="$t('Term-End')"
                                        v-bind:detaygizle="true"
                                        v-bind:defaultvalue="'ok'"
                                        @input="endDateChange()"
                                        v-bind:value="val.kalem.donem2"
                                        v-model="val.kalem.donem2"
                                      ></tarihcomp>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                              <v-flex pl-1 xs12 sm12 md12>
                                <v-select
                                  hide-details
                                  :items="odemeTipi"
                                  :label="$t('Payment-Type')"
                                  item-text="aciklama"
                                  item-value="kod"
                                  v-model="val.kalem.odeyenTaraf"
                                >
                                </v-select>
                              </v-flex>
                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <v-select
                                  hide-details
                                  :items="pansiyon"
                                  :label="$t('Hostel-Type')"
                                  item-text="aciklama"
                                  item-value="kod"
                                  v-model="val.kalem.kalemOtel.pansiyon"
                                ></v-select>
                              </v-flex>
                              <v-flex
                                pl-1
                                pt-2
                                xs12
                                sm12
                                md12
                                v-if="val.kalem.saticiTip == 1"
                              >
                                <v-btn
                                  color="info"
                                  class="white--text"
                                  outline
                                  @click="fiyatSec(val.kalem, 2)"
                                >
                                   {{ $t('Recalculate-Price') }}
                                  <v-icon right dark>play_arrow</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>

                            <template v-if="val.kalem.saticiTip == 10">
                              <v-textarea
                                hide-details
                                :label="$t('Job-Explanation')"
                                v-model="val.kalem.kalemDiger.isAciklama"
                              ></v-textarea>
                            </template>
                          </v-flex>

                          <v-flex pl-1 xs3 sm3 md3>
                            <v-layout row wrap>
                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <v-menu
                                  ref="menuacilis"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="
                                    val.kalem.kalemOtel.girisSaati
                                  "
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      hide-details
                                      v-model="val.kalem.kalemOtel.girisSaati"
                                      :label="$t('Entry-Date')"
                                      append-icon="access_time"
                                      v-on="on"
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="menu2"
                                    format="24hr"
                                    v-model="val.kalem.kalemOtel.girisSaati"
                                    full-width
                                    @click:minute="
                                      $refs.menuacilis.save(
                                        val.kalem.kalemOtel.girisSaati
                                      )
                                    "
                                  >
                                  </v-time-picker>
                                </v-menu>
                              </v-flex>

                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <!-- <genelarama apiname="OdaTipiAra" label="OdaTipi "
                                                                    v-model="val.kalem.kalemOtel.odaTipi"></genelarama> -->

                                <v-autocomplete
                                  hide-details
                                  :items="odatipiitems"
                                  :label="$t('Room-Type')"
                                  item-text="isim"
                                  return-object
                                  v-model="val.kalem.kalemOtel.odaTipi"
                                >
                                </v-autocomplete>
                              </v-flex>
                               
                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                               <v-text-field v-model="nightCount" :label="$t('Number-of-Nights')" hide-details disabled>
                                   
                                </v-text-field>
                              </v-flex>
                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <genelaramakod
                                  apiname="OdaKonumAra"
                                  :tip="val.kalem.satici.kod"
                                  hide-details
                                  :label="$t('Location')"
                                  v-model="val.kalem.kalemOtel.konum"
                                >
                                </genelaramakod>
                              </v-flex>
                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <v-text-field
                                  type="number"
                                  hide-details
                                  label="Oda Sayısı"
                                  v-model="val.kalem.kalemOtel.odaSayi"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <geneltipara
                                  tip="OtelFiyatKod"
                                  label="fiyatKodu"
                                  v-model="val.kalem.kalemOtel.fiyatKodu"
                                >
                                </geneltipara>
                              </v-flex>

                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <v-text-field
                                  type="number"
                                  hide-details
                                  :label="$t('Free-Person-Number')"
                                  v-model="val.kalem.kalemOtel.freeKisi"
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex
                                pl-1
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <v-checkbox
                                  hide-details
                                  :label="$t('Capacity')"
                                  v-model="val.kalem.kalemOtel.kontenjan"
                                >
                                </v-checkbox>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex pl-1 xs4 sm4 md4>
                            <v-layout row wrap>
                              <v-flex
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <kur
                                  v-model="val.kalem.satisPara"
                                  :kurtarihi="val.Rez.kayitTarihi"
                                ></kur>
                              </v-flex>

                              <v-flex
                                v-if="val.kalem.saticiTip == 1"
                                xs12
                                sm12
                                md12
                              >
                                <yuzdeinput
                                :isPositive="true"
                                  :etiket="$t('VAT-Ratio')"
                                  v-model="val.kalem.satis.KDVOran"
                                  :autocomplete="'autocomplete'"
                                ></yuzdeinput>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-radio-group
                                  row
                                  hide-details
                                  v-model="val.kalem.P_RP"
                                  column
                                >
                                  <v-radio label="Pax" :value="'P'"></v-radio>
                                  <v-radio :label="$t('Fix')" :value="'R'"></v-radio>
                                </v-radio-group>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                      :etiket="$t('Adult-Sales')"
                                      v-model="val.kalem.yet_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.yet_KisiSayisi"
                                      :label="$t('Number')"
                                      :rules="[v => !!v || $t('Mandatory-section')]"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex
                                v-if="val.kalem.P_RP == 'P'"
                                xs12
                                sm12
                                md12
                              >
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                      :etiket="$t('Co1Sell')"
                                      v-model="val.kalem.co1_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.co1_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex
                                v-if="val.kalem.P_RP == 'P'"
                                xs12
                                sm12
                                md12
                              >
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                      :etiket="$t('Co2Sell')"
                                      v-model="val.kalem.co2_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.co2_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex
                                v-if="val.kalem.P_RP == 'P'"
                                xs12
                                sm12
                                md12
                              >
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                      :etiket="$t('Co3Sell')"
                                      v-model="val.kalem.co3_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.co3_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex
                                v-if="val.kalem.P_RP == 'P'"
                                xs12
                                sm12
                                md12
                              >
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                      :etiket="$t('Co4Sell')"
                                      v-model="val.kalem.co4_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.co4_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex
                                v-if="val.kalem.P_RP == 'P'"
                                xs12
                                sm12
                                md12
                              >
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                       :etiket="this.$t('EKYSell')"
                                      v-model="val.kalem.ekY_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.ekY_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <yuzdeinput
                                    :isPositive="true"
                                      :etiket="$t('Discount-rate')"
                                      v-model="val.kalem.iskonto.oran"
                                      :autocomplete="'autocomplete'"
                                    ></yuzdeinput>
                                  </v-flex>
                                  <v-flex xs6 sm6 md6>
                                    <parainput
                                    :isPositive="true"
                                      :simge="getparabirimi()"
                                      :etiket="$t('Discount-Amount') + ' 2'"
                                      v-model="val.kalem.iskonto.tutar"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pb-2 xs12 sm12 md12>
                                <v-text-field
                                  hide-details
                                  :label="$t('Discount-Reason')"
                                  v-model="val.kalem.iskonto.iskontoSebebi"
                                >
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-ozel`">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat color="grey lighten-5">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 md12>
                            <v-layout row wrap>
                              <v-flex pl-1 pb-2 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md6>
                                    <genelarama
                                      apiname="MasrafMerkeziAra"
                                      :label="$t('Expense-Center-v2')"
                                      v-model="val.kalem.masrafMerkezi"
                                    >
                                    </genelarama>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <geneltipara
                                      tip="AcenteDepartman"
                                      v-model="val.kalem.departman"
                                    >
                                    </geneltipara>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <getKurList
                                      v-model="
                                        val.kalem.acenteKomisyon.paraBirimi
                                      "
                                      :kurTarihi="val.Rez.kayitTarihi"
                                      :label="$t('Agency-Commission-Currency')"
                                    ></getKurList>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <getKurDeger
                                      v-model="val.kalem.acenteKomisyon.kur"
                                      :label="$t('Agency-Commission-Exchange-Rate')"
                                      :kurTarihi="val.Rez.kayitTarihi"
                                      :paraTip="
                                        val.kalem.acenteKomisyon.paraBirimi
                                      "
                                    ></getKurDeger>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6>
                                    <v-text-field
                                      v-model="
                                        val.kalem.acenteKomisyon.DovizTutar
                                      "
                                      :label="$t('Agency-Commission-Amount')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-maliyet`">
                  <v-layout row wrap>
                    <v-card flat color="grey lighten-5">
                      <v-flex xs12 sm12 pa-1 md12>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md11>
                            <cariaracomp
                              v-bind:etiket="$t('Cost-Current')"
                              v-bind:value="val.kalem.maliyetCariKod.kod"
                              v-model="val.kalem.maliyetCariKod.kod"
                              :Coper="true"
                            ></cariaracomp>
                          </v-flex>
                           <v-flex xs12 sm12 md1 pt-2>
                            <v-tooltip bottom>
                               <v-btn @click="getMaliyetCari()"  slot="activator" flat icon color="primary">
                              <v-icon>swipe_left_alt</v-icon>
                            </v-btn>
                            <span> {{$t('Bring-Seller-Client')}} </span>
                            </v-tooltip>
                           </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              hide-details
                              :label="$t('Profit-VAT')"
                              mask="#####"
                              v-model="val.kalem.karKDV"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <kur
                              v-model="val.kalem.alisPara"
                              :kurtarihi="val.Rez.kayitTarihi"
                            >
                            </kur>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <template v-if="val.kalem.saticiTip == 1">
                              <v-combobox
                                hide-details
                                :label="$t('Rom-Pax-Total')"
                                v-model="val.kalem.kalemOtel.RP"
                                :items="['R', 'P', 'T']"
                              >
                              </v-combobox>
                            </template>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <kredikartodemetipi
                              v-model="val.kalem.KKartOdemeTipi"
                              @input="kKartKontrol()"
                            ></kredikartodemetipi>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <kredikartnoara
                              v-bind:value="val.kalem.KKartNo"
                              v-model="val.kalem.KKartNo"
                              v-bind:kartTipi="val.kalem.KKartOdemeTipi"
                            ></kredikartnoara>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                  :etiket="$t('YetBuying')"
                                  v-model="val.kalem.yet_Alis"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>

                              <v-flex
                                xs12
                                v-if="
                                  val.kalem.saticiTip == 1 ||
                                  val.kalem.saticiTip == 2 ||
                                  val.kalem.saticiTip == 4 ||
                                  val.kalem.saticiTip == 10 ||
                                  val.kalem.saticiTip == 8 ||
                                  val.kalem.saticiTip == 9
                                "
                                sm12
                                md12
                              >
                                <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                  :etiket="$t('co1buying')"
                                  v-model="val.kalem.co1_Alis"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>

                              <v-flex
                                xs12
                                v-if="
                                  val.kalem.saticiTip == 1 ||
                                  val.kalem.saticiTip == 2 ||
                                  val.kalem.saticiTip == 8 ||
                                  val.kalem.saticiTip == 10 ||
                                  val.kalem.saticiTip == 9
                                "
                                sm12
                                md12
                              >
                                <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                   :etiket="this.$t('co2buying')"
                                  v-model="val.kalem.co2_Alis"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>

                              <v-flex
                                xs12
                                v-if="
                                  val.kalem.saticiTip == 1 ||
                                  val.kalem.saticiTip == 10 ||
                                  val.kalem.saticiTip == 9
                                "
                                sm12
                                md12
                              >
                                <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                  :etiket="this.$t('co3buying')"
                                  v-model="val.kalem.co3_Alis"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>

                              <v-flex
                                xs12
                                v-if="
                                  val.kalem.saticiTip == 1 ||
                                  val.kalem.saticiTip == 10 ||
                                  val.kalem.saticiTip == 9
                                "
                                sm12
                                md12
                              >
                                <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                   :etiket="this.$t('co4buying')"
                                  v-model="val.kalem.co4_Alis"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>

                              <v-flex
                                xs12
                                v-if="
                                  val.kalem.saticiTip == 1 ||
                                  val.kalem.saticiTip == 10 ||
                                  val.kalem.saticiTip == 9
                                "
                                sm12
                                md12
                              >
                                <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                   :etiket="this.$t('EKYBuying')"
                                  v-model="val.kalem.ekY_Alis"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md6 v-if="val.kalem.saticiTip == 1">
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-checkbox
                                  hide-details
                                  :label="$t('Receive-Commission-from-Tour-excluding-VAT')"
                                  v-model="val.kalem.kalemOtel.KomKDVHaric"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-checkbox
                                  :label="$t('Excluding-breakfast')"
                                  hide-details
                                  v-model="val.kalem.kalemOtel.KomKahvaltiHaric"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-checkbox
                                  :label="$t('Excluding-lunch')"
                                  hide-details
                                  v-model="
                                    val.kalem.kalemOtel.KomOgleYemegiHaric
                                  "
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-checkbox
                                  :label="$t('Excluding-dinner')"
                                  hide-details
                                  v-model="
                                    val.kalem.kalemOtel.KomAksamYemegiHaric
                                  "
                                ></v-checkbox>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                              <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                  :etiket="'MasterSatisTutar'"
                                  v-model="val.kalem.MasterSatisTutar"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                              <parainput
                                :isPositive="true"
                                  :simge="getparabirimi()"
                                  :etiket="'MasterAlisTutar'"
                                  v-model="val.kalem.MasterAlisTutar"
                                  :autocomplete="'autocomplete'"
                                >
                                </parainput>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
 
                              <v-flex pl-1 xs12 sm6 md6>
                                <v-select
                                  hide-details
                                  :items="vergiHesapTipi"
                                  label="Konaklama Vergisi"
                                  item-text="text"
                                  item-value="value"
                                  v-model="val.kalem.VergiHesapTipi"
                                >
                                </v-select>
                              </v-flex>  

                            </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-layout>

                  <!-- <template
                                v-if="(val.kalem.saticiTip==3)||(val.kalem.saticiTip==5)||(val.kalem.saticiTip==7)||(val.kalem.saticiTip==7) ||(val.kalem.saticiTip==11)||(val.kalem.saticiTip==14) || (val.kalem.saticiTip==15) || (val.kalem.saticiTip==16)">

                            </template> -->
                </v-tab-item>

                <v-tab-item :id="`tab-komisyon`">
                  <v-layout row wrap>
                    <v-card flat color="grey lighten-5">
                      <v-flex xs12 sm12 pa-1 md12>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-autocomplete
                              hide-details
                              :label="$t('Calculate-Commission-Percentage')"
                              v-model="val.kalem.komisyonYuzdeTip"
                              item-text="t"
                              item-value="v"
                              :items="[
                                { t: $t('Calculate-From-Sales-Price'), v: 0 },
                                { t: $t('Calculate-From-Purchasing-Price'), v: 1 },
                              ]"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <yuzdeinput
                            :isPositive="true"
                              :etiket="$t('Commission-Percentage')"
                              v-model="val.kalem.komisyonYuzde"
                              :autocomplete="'autocomplete'"
                            ></yuzdeinput>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <parainput
                            :isPositive="true"
                              :simge="getparabirimi()"
                              :etiket="$t('Commission-Amount-v2')"
                              v-model="val.kalem.komisyonTutar"
                              :autocomplete="'autocomplete'"
                            ></parainput>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <kur
                              v-model="val.kalem.komisyonPara"
                              :kurtarihi="val.Rez.kayitTarihi"
                            >
                            </kur>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              :label="$t('Commission-VAT')"
                              v-model="val.kalem.komisyon.KDVOran"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-aciklama`">
                  <v-card flat color="grey lighten-5">
                    <v-flex xs12 sm12 pa-1 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-textarea
                            hide-details
                            :label="$t('Descriptions')"
                            v-model="val.kalem.aciklama"
                          >
                          </v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-textarea
                            hide-details
                            :label="$t('Supplier-Explanations')"
                            v-model="val.kalem.tedarikciAciklama"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-tab-item>

                <v-tab-item :id="`tab-diger`">
                  <v-card flat color="grey lighten-5">
                    <v-flex xs12 sm12 pa-1 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            hide-details
                            :label="$t('Integration-Code')"
                            v-model="val.kalem.entegrasyonKodu"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <geneltipara
                            tip="CariKdvKod"
                            hide-details
                            :label="$t('VAT-Code')"
                            v-model="val.kalem.kdvID"
                          >
                          </geneltipara>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <geneltipara
                            tip="CariKdvIstisnaKod"
                            hide-details
                            :label="$t('VAT-Exception-Code')"
                            v-model="val.kalem.kdvMuafiyetID"
                          >
                          </geneltipara>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md3 sm3>
          <v-flex xs12 sm12 md12>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 pa-2 sm12 md12>
                  <v-layout row wrap>
                    <v-flex pl-1 xs12 sm12 md12>
                      <v-layout justify-center>
                        <v-checkbox
                          v-model="tumunusec"
                          :label="$t('Person-List')"
                          color="info"
                          hide-details
                        >
                        </v-checkbox>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex
                  pa-2
                  v-for="item in val.Kisiler"
                  v-bind:key="item.id"
                  xs12
                  sm12
                  md12
                >
                  <v-card flat="">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs2 sm2 md2>
                              <v-layout
                                align-start=""
                                justify-start
                                fill-height
                              >
                                <v-card flat="">
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>
                                      <div
                                        class="font-weight grey--text caption"
                                      >
                                        <v-checkbox
                                          v-model="secilenkayitlar"
                                          :value="item"
                                          hide-details
                                        >
                                        </v-checkbox>
                                      </div>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title>
                                      <div
                                        class="font-weight green--text body-2"
                                      >
                                        &nbsp;
                                      </div>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs5 sm5 md5>
                              <v-layout
                                align-center=""
                                justify-start=""
                                fill-height=""
                              >
                                <v-icon color="red">person</v-icon>
                                <span
                                  class="
                                    caption
                                    black--text
                                    font-weight-regular
                                  "
                                >
                                  {{ KisiTipToStr(item.kisiTip) }}
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs5 sm5 md5>
                              <v-layout
                                align-center=""
                                justify-start=""
                                fill-height=""
                              >
                                <span
                                  class="
                                    caption
                                    black--text
                                    font-weight-regular
                                  "
                                >
                                  {{ item.adSoyad }}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 pa-2 sm12 md12>
                  <v-layout row wrap>
                    <v-flex v-if="val.islem == 'new'" pb-1 xs12 sm12 md12>
                      <v-btn outline @click="kalemekle()" block color="info">
                        {{$t('Add-Reservation-List')}}</v-btn
                      >
                    </v-flex>
                    <v-flex
                      @click="kalemguncelle()"
                      v-if="val.islem == 'edit'"
                      pb-1
                      xs12
                      sm12
                      md12
                    >
                      <v-btn outline block color="info"> {{ $t('Update') }}</v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 md12>
                      <v-btn
                        outline
                        @click.native="val.aktif = false"
                        block
                        color="info"
                        >{{ $t("cancel_button") }}
                      </v-btn>
                    </v-flex> -->
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog
      persistent
      max-width="1000px"
      v-model="dialogFiyat"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-card-title style="background-color: #01579b">
          <span class="headline white--text"> {{ $t('Select-Hotel-Price') }} </span>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-form ref="saticiortakbilgi">
                <v-flex xs12 sm12 md12 pa-1>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md4>
                      <tarihcomp
                        :etiket="$t('Check-in-Date')"
                        v-model="getFiyatListRequest.GirisTarihi"
                        v-bind:detaygizle="true"
                        v-bind:defaultvalue="'ok'"
                      ></tarihcomp>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <tarihcomp
                        :etiket="$t('Check-out-Date')"
                        v-model="getFiyatListRequest.CikisTarihi"
                        v-bind:detaygizle="true"
                        v-bind:defaultvalue="'ok'"
                      ></tarihcomp>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-text-field
                        :label="$t('Category')"
                        hide-details
                        v-model="getFiyatListRequest.Kategori"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <genelarama
                        apiname="SaticiAra"
                        v-model="getFiyatListRequest.OtelKod"
                        :tip="1"
                        :label="$t('Hotel')"
                      ></genelarama>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <geneltipara
                        tip="OtelFiyatKod"
                        v-model="getFiyatListRequest.FiyatKodu"
                        :label="$t('Price-Code')"
                      ></geneltipara>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-select
                        hide-details
                        :items="dialogPansiyon"
                        :label="$t('Hostel-Type')"
                        item-text="aciklama"
                        item-value="kod"
                        v-model="getFiyatListRequest.Pansiyon"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 pa-1>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md3>
                      <v-autocomplete
                        :items="ulkeItems"
                        hide-details=""
                        @change="getSehirItems()"
                        v-model="getFiyatListRequest.Ulke"
                        item-text="Isim"
                        item-value="Id"
                        clearable
                        :label="$t('Country_label')"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md3>
                      <v-autocomplete
                        :items="sehirItems"
                        hide-details=""
                        @change="getIlceItems()"
                        v-model="getFiyatListRequest.Sehir"
                        item-text="Isim"
                        item-value="Id"
                        clearable
                        :label="$t('Province')"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md3>
                      <v-autocomplete
                        :items="ilceItems"
                        hide-details=""
                        @change="getSemtItems()"
                        v-model="getFiyatListRequest.Yer"
                        item-text="Isim"
                        item-value="Id"
                        clearable
                        :label="$t('District')"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md3>
                      <v-autocomplete
                        :items="semtItems"
                        hide-details=""
                        v-model="getFiyatListRequest.SaticiKonumu"
                        item-text="Isim"
                        item-value="Id"
                        clearable
                        :label="$t('District-v2')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 pa-1>
                  <v-layout row wrap column child-flex>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Fiyat Listesi</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="fiyatBulLoad"
                        :disabled="fiyatBulLoad"
                        color="info"
                        @click="getPriceList()"
                      >
                        {{ $t('Find-Price') }}
                        <template v-slot:loader>
                          <span class="custom-loader">
                            <v-icon light>cached</v-icon>
                          </span>
                        </template>
                      </v-btn>
                    </v-toolbar>
                    <v-data-table
                      width="950px"
                      :headers="fiyatHeaders"
                      ref="itemsTable"
                      expand
                      :items="fiyatItems"
                      item-key="Isim"
                    >
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-xs-left">{{ props.item.Isim }}</td>
                          <td class="text-xs-left">{{ props.item.Yer }}</td>
                          <td class="text-xs-left">
                            {{ props.item.OperatorKod }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.Pansiyon }}
                          </td>
                          <td class="text-xs-left">{{ props.item.OdaTip }}</td>
                          <td class="text-xs-left">{{ props.item.Konum }}</td>
                          <td class="text-xs-left">
                            {{ props.item.FiyatAdi }}
                          </td>
                          <td class="text-xs-left">{{ props.item.Tutar }}</td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <div class="mt-2">
                          <template v-for="i in props.item.Details.length">
                            <td class="text-xs-left" :key="i">
                              <span class="body-2">
                                {{
                                  props.item.Details[i - 1].Tarih | getDayName
                                }}
                              </span>
                              <p class="body-1">
                                {{ props.item.Details[i - 1].YetSatis }}
                                {{ props.item.Details[i - 1].ParaBirimi }}
                              </p>
                            </td>
                          </template>
                          <template v-for="k in 7 - props.item.Details.length">
                            <td class="text-xs-left" :key="'A' + k">
                              <span class="body-2">
                                {{
                                  props.item.Details[
                                    props.item.Details.length - 1
                                  ].Tarih | getOtherDayName(k)
                                }}
                              </span>
                              <p></p>
                            </td>
                          </template>
                          <td></td>
                          <td justify-end>
                            <v-btn
                              color="info"
                              class="white--text"
                              small
                              @click="fiyatSec(props.item, 1)"
                            >
                              {{ $t('Select') }}
                              <v-icon right dark>play_arrow</v-icon>
                            </v-btn>
                          </td>
                        </div>
                      </template>
                    </v-data-table>
                  </v-layout>
                </v-flex>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click.native="cancel">{{
            $t("cancel_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import rez from "../../mice";
import kur from "@/components/app/coper/comp/kur.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
import tarihcomp from "../../../customcomp/tarihim";
import parainput from "../../../customcomp/parainput";
import yuzdeinput from "../../../customcomp/yuzdeinput";
import tool from "../../tools";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import kredikartodemetipi from "@/components/app/coper/comp/kredikartodemetipi.vue";
import kredikartnoara from "@/components/app/coper/comp/kredikartnoara.vue";
import getKurDeger from "../../comp/getKurDeger.vue";
import getKurList from "../../comp/getKurList.vue";
import resultDialog from "@/components/app/customcomp/resultDialog.vue"

export default {
  components: {
    resultDialog,
    kur,
    genelarama,
    genelaramakod,
    tarihcomp,
    geneltipara,
    parainput,
    yuzdeinput,
    minisaticieklecomp,
    cariaracomp,
    snackbarcomp,
    kredikartnoara,
    kredikartodemetipi,
    getKurDeger,
    getKurList,
  },
  filters: {
    getDayName: function (t) {
      var d = new Date(t);
      return d.toLocaleDateString("tr-TR", {
        weekday: "long",
      });
    },
    getOtherDayName: function (tarih, gun) {
      if (7 > gun) {
        var date = new Date(tarih);
        date.setDate(date.getDate() + gun);
        return date.toLocaleDateString("tr-TR", {
          weekday: "long",
        });
      }
    },
  },
  watch: {
    fiyatBulLoad() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    "val.kalem.satici.kod": function (val1) {
      this.val.kalem.satis.KDVOran = parseFloat(this.val.kalem.satici.KDV);

      //      if (this.val.kalem.satici.YurtIci_YurtDisi == 0) {
      //    this.val.kalem.satis.KDVOran = 18
      //      } else {
      //          this.val.kalem.satis.KDVOran = 8
      //      }
    },
    "val.kalem.P_RP": function (val) {
      if (val == "R") {
        this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
      } else {
        this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;

        this.secilenkayitlar.forEach((element) => {
          if (element.kisiTip == 0) {
            this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
          } else if (element.kisiTip == 1) {
            this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
          } else if (element.kisiTip == 2) {
            this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
          } else if (element.kisiTip == 3) {
            this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
          } else if (element.kisiTip == 4) {
            this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
          } else if (element.kisiTip == 5) {
            this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
          }
        });
      }
    },
    tumunusec(valsec) {
      if (valsec == true) {
        this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
        for (var i = 0; i < this.val.Kisiler.length; i++) {
          this.secilenkayitlar.push(this.val.Kisiler[i]);
        }
        if (this.val.kalem.P_RP == "R") {
          this.val.kalem.yet_KisiSayisi = this.val.Kisiler.length;
        } else {
          this.val.kalem.yet_KisiSayisi = 0;
          this.val.kalem.co1_KisiSayisi = 0;
          this.val.kalem.co2_KisiSayisi = 0;
          this.val.kalem.co3_KisiSayisi = 0;
          this.val.kalem.co4_KisiSayisi = 0;
          this.val.kalem.ekY_KisiSayisi = 0;

          this.secilenkayitlar.forEach((element) => {
            if (element.kisiTip == 0) {
              this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
            } else if (element.kisiTip == 1) {
              this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
            } else if (element.kisiTip == 2) {
              this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
            } else if (element.kisiTip == 3) {
              this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
            } else if (element.kisiTip == 4) {
              this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
            } else if (element.kisiTip == 5) {
              this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
            }
          });
        }
      } else {
        this.secilenkayitlar = [];
        this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }
    },
    secilenkayitlar: function (val) {
      if (this.counter == 0 && this.val.islem != "new") {
        this.counter = this.counter + 1;
      } else {
        if (this.val.kalem.P_RP == "R") {
          this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        } else {
          this.val.kalem.yet_KisiSayisi = 0;
          this.val.kalem.co1_KisiSayisi = 0;
          this.val.kalem.co2_KisiSayisi = 0;
          this.val.kalem.co3_KisiSayisi = 0;
          this.val.kalem.co4_KisiSayisi = 0;
          this.val.kalem.ekY_KisiSayisi = 0;

          val.forEach((element) => {
            if (element.kisiTip == 0) {
              this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
            } else if (element.kisiTip == 1) {
              this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
            } else if (element.kisiTip == 2) {
              this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
            } else if (element.kisiTip == 3) {
              this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
            } else if (element.kisiTip == 4) {
              this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
            } else if (element.kisiTip == 5) {
              this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
            }
          });
        }
      }
    },
  },

  props: ["value"],
  computed: {
    val: {
      get: function () {
        var prm = {
          id: null,
          kod: null,
          aciklama: null,
          tip: 1,
        };

        tool.http_post(this, "OdaTipiAra", prm).then(
          (response) => {
            this.odatipiitems = response.body;
          },
          (response) => {
            //   this.status = tool.responseToStatus(response);
          }
        );
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    pansiyon: {
      get: function () {
        return rez.Pansiyon;
      },
    },
  },

  data() {
    return {
      saticiItems:[],
      kalemDataBackup: {},
      loader: null,
      fiyatBulLoad: false,
      text1: "",
      snackbar: false,
      exploded: false,
      expanded: [],
      fiyatHeaders: [
        {
          text: "Otel Adı",
          value: "Isim",
        },
        {
          text: this.$t('Category'),
          value: "Yer",
        },
        {
          text: this.$t('Operator-Code'),
          value: "OperatorKod",
        },
        {
          text: "Pansiyon",
          value: "Pansiyon",
        },
        {
          text: "Oda Tip",
          value: "OdaTip",
        },
        {
          text: this.$t('Location'),
          value: "Konum",
        },
        {
          text: "Fiyat Adı",
          value: "FiyatAdi",
        },
        {
          text: "Tutar",
          value: "Tutar",
        },
      ],
      fiyatItems: [],
      ulkeItems: [],
      sehirItems: [],
      ilceItems: [],
      semtItems: [],
      dialogFiyat: false,
      dialogPansiyon: rez.PansiyonWithNull,
      getFiyatListRequest: {
        GirisTarihi: null,
        CikisTarihi: null,
        CariKod: "",
        OtelKod: "",
        OperatorKod: "",
        Pansiyon: null,
        OdaTip: "",
        Konum: "",
        Ulke: "",
        Sehir: "",
        Yer: "",
        SaticiKonumu: "",
        SiralamaTipi: 4,
        Kategori: "",
        FiyatKodu: "",
      },
      nightCount:0,
      odatipiitems: [],
      menu2: false,
      tumunusec: true,
      secilenkayitlar: [],
      dialogShow: false,
      error: "",
      adresler: [],
      search: "",
      selected: [],
      odemeTipi: rez.OdemeTipi,
      vergiHesapTipi: rez.VergiHesapTipi(),
      
      counter: 0,
      tabmodel: "tab-genel",
      kisiSira: [],
      headers: [
        {
          text: "Isim",
          align: "left",
          value: "adSoyad",
          sortable: false,
        },
      ],
      menuItems: [
        // {
        //   title: "Hotel Runner Otel Bul (Beta)",
        // },
        {
          title: this.$t('Calculate-Price')
        },
      ],
    };
  },

  mounted() {
    
    if (this.val.islem == "new") {
      this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
      this.secilenkayitlar = [];
      for (var i = 0; i < this.value.Kisiler.length; i++) {
        this.secilenkayitlar.push(this.value.Kisiler[i]);
      }
    } else {
      this.secilenkayitlar = [];
      this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
      for (var i = 0; i < this.value.kalem.kisiSira.length; i++) {
        this.secilenkayitlar.push(
          this.value.Rez.adresler[this.value.kalem.kisiSira[i]]
        );
      }
    }
    
  },
  methods: {
    getOtelItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 1,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
          this.saticiItems = [];
          for (var i = 0; i < response.body.length; i++) {
            this.saticiItems.push({
              id: response.body[i].id,
              isim: response.body[i].isim,
              KDV:response.body[i].KDV,
              kod: response.body[i].kod,
              CariKod:response.body[i].CariKod,
              YurtIci_YurtDisi:response.body[i].YurtIci_YurtDisi,
             
            });
          }

          
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getMaliyetCari(){
      this.val.kalem.maliyetCariKod.kod = this.val.kalem.satici.CariKod;
    },
    endDateChange(){
      const date1 = new Date(this.val.kalem.donem1);
      const date2 = new Date(this.val.kalem.donem2);
      var t2 = date2.getTime();
      var t1 = date1.getTime();
 
      this.nightCount = parseInt((t2-t1)/(24*3600*1000));
       
    },
    startDateChange(){
      var date = this.val.kalem.donem1.split('-');
      var changeDate = new Date(date[0],(date[1] - 1),date[2]);
      changeDate.setDate(changeDate.getDate() + 1);
      var day;
      var month;
      var year = changeDate.getFullYear();
      if(10 > changeDate.getDate()){
         day = '0' + changeDate.getDate(); 
      }else{
        day = changeDate.getDate();
      }
      if(9 > changeDate.getMonth()){
        month = '0' + (changeDate.getMonth() + 1); 
      }else{
        month = (changeDate.getMonth() + 1);
      }
      this.val.kalem.donem2  =  year + "-" + month + "-" + day;
      this.nightCount = 1;
    },
    kKartKontrol() {
      this.val.kalem.KKartNo = "";
    },
    fiyatSec(fiyatData, tip) {
      // 1 :  dialogda listelemeden seçme 2: rez sihirbazından hızlı seçme
      var _kisiItems = [];
      let params = null;
      for (var i = 0; i < this.val.Kisiler.length; i++) {
        var _kisi = {
          KisiTip: this.val.Kisiler[i].kisiTip,
          KisiYas: this.val.Kisiler[i].yas,
        };
        _kisiItems.push(_kisi);
      }
      if (tip == 1) {
        this.dialogFiyat = false;
        params = {
          GirisTarihi: this.getFiyatListRequest.GirisTarihi,
          CikisTarihi: this.getFiyatListRequest.CikisTarihi,
          CariKod: this.val.Rez.cariKod.kod,
          OtelKod: fiyatData.OtelKod,
          OperatorKod: fiyatData.OperatorKod,
          Pansiyon: this.getFiyatListRequest.Pansiyon,
          OdaTip: fiyatData.OdaTip,
          FiyatKodu: fiyatData.FiyatKodu,
          KayitTarihi: this.val.Rez.kayitTarihi,
          AcenteKod: this.val.Rez.acenteDepartman.kod,
          OdaKonum: fiyatData.Konum,
          OdaSayi: this.val.kalem.kalemOtel.odaSayi,
          KisiTipYasList: _kisiItems,
        };
      } else {
        var _pansiyonKod = rez.Pansiyon.find(
          (x) => x.kod === this.val.kalem.kalemOtel.pansiyon
        );

        var _konumValue;
        var _otelKodValue;
        var _fiyatKodValue;
        var _acenteKodValue;
        var _odaTipiValue;
        var _turOperatoruKodValue;

        if (this.val.kalem.turOperatoru.kod != null) {
          _turOperatoruKodValue = this.val.kalem.turOperatoru.kod;
        } else {
          _turOperatoruKodValue = null;
        }

        if (this.val.kalem.kalemOtel.odaTipi.kod != null) {
          _odaTipiValue = this.val.kalem.kalemOtel.odaTipi.kod;
        } else {
          _odaTipiValue = null;
        }

        if (this.val.kalem.kalemOtel.konum != null) {
          _konumValue = this.val.kalem.kalemOtel.konum.kod;
        } else {
          _konumValue = null;
        }

        if (this.val.Rez.acenteDepartman != null) {
          _acenteKodValue = this.val.Rez.acenteDepartman.kod;
        } else {
          _acenteKodValue = null;
        }

        if (
          this.val.kalem.satici != null &&
          this.val.kalem.satici != "undefined"
        ) {
          _otelKodValue = this.val.kalem.satici.kod;
        } else {
          _otelKodValue = null;
        }

        if (
          this.val.kalem.kalemOtel.fiyatKodu.id != null &&
          this.val.kalem.kalemOtel.fiyatKodu.id != "undefined"
        ) {
          _fiyatKodValue = this.val.kalem.kalemOtel.fiyatKodu.id;
        } else {
          _fiyatKodValue = null;
          this.text1 = "Otel Fiyat Kodu Boş olamaz";
          this.snackbar = true;
          return false;
        }

        params = {
          GirisTarihi: this.val.kalem.donem1,
          CikisTarihi: this.val.kalem.donem2,
          CariKod: this.val.Rez.cariKod.kod,
          OtelKod: _otelKodValue,
          OperatorKod: _turOperatoruKodValue,
          Pansiyon: _pansiyonKod.kod,
          OdaTip: _odaTipiValue,
          FiyatKodu: _fiyatKodValue,
          KayitTarihi: this.val.Rez.kayitTarihi,
          AcenteKod: _acenteKodValue,
          OdaKonum: _konumValue,
          OdaSayi: this.val.kalem.kalemOtel.odaSayi,
          KisiTipYasList: _kisiItems,
        };
      }

      tool.http_post(this, "OtelFiyatHesapla", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.val.kalem.satici = response.body.data.Otel;
            this.val.kalem.kalemOtel.fiyatKodu = response.body.data.FiyatTanimi;
            this.val.kalem.kalemOtel.konum = response.body.data.OdaKonum.kod;
            this.val.kalem.kalemOtel.odaTipi = response.body.data.OdaTipi;
            this.val.kalem.turOperatoru = response.body.data.TurOperatoru;
            if (_pansiyonKod != undefined) {
              this.val.kalem.kalemOtel.pansiyon = _pansiyonKod.kod;
            }
            if (tip == 1) {
              this.val.kalem.donem1 = this.getFiyatListRequest.GirisTarihi;
              this.val.kalem.donem2 = this.getFiyatListRequest.CikisTarihi;
            }
            this.val.kalem.komisyonYuzdeTip =
              response.body.data.KomisyonHesapSecenegi;
            this.val.kalem.komisyonTutar = response.body.data.Komisyon;

            this.val.kalem.alisPara.paraBirimi =
              response.body.data.AlisParaBirimi;
            this.val.kalem.satisPara.paraBirimi = response.body.data.ParaBirimi;

            //this.val.kalem.kalemOtel.RP = response.body.data.R_P;

            this.val.kalem.yet_Satis = response.body.data.YetSatis;
            this.val.kalem.co1_Satis = response.body.data.Co1Satis;
            this.val.kalem.co2_Satis = response.body.data.Co2Satis;
            this.val.kalem.co3_Satis = response.body.data.Co3Satis;
            this.val.kalem.co4_Satis = response.body.data.Co4Satis;
            this.val.kalem.ekY_Satis = response.body.data.EkYSatis;

            this.val.kalem.yet_Alis = response.body.data.YetAlis;
            this.val.kalem.co1_Alis = response.body.data.Co1Alis;
            this.val.kalem.co2_Alis = response.body.data.Co2Alis;
            this.val.kalem.co3_Alis = response.body.data.Co3Alis;
            this.val.kalem.co4_Alis = response.body.data.Co4Alis;
            this.val.kalem.ekY_Alis = response.body.data.EkYAlis;
            this.fiyatItems.length = 0;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );
    },
    getPriceList() {
      this.fiyatBulLoad = true;
      this.fiyatItems = [];
      this.exploded = false;

      var _konumValue;
      var _otelKodValue;
      var _fiyatKodValue;
      if (this.val.kalem.kalemOtel.konum != null) {
        _konumValue = this.val.kalem.kalemOtel.konum.kod;
      } else {
        _konumValue = null;
      }

      if (
        this.getFiyatListRequest.OtelKod.kod != null &&
        this.getFiyatListRequest.OtelKod.kod != "undefined"
      ) {
        _otelKodValue = this.getFiyatListRequest.OtelKod.kod;
      } else {
        _otelKodValue = null;
      }

      if (
        this.getFiyatListRequest.FiyatKodu.id != null &&
        this.getFiyatListRequest.FiyatKodu.id != "undefined"
      ) {
        _fiyatKodValue = this.getFiyatListRequest.FiyatKodu.id;
      } else {
        _fiyatKodValue = null;
      }

      let params = {
        GirisTarihi: this.getFiyatListRequest.GirisTarihi,
        CikisTarihi: this.getFiyatListRequest.CikisTarihi,
        CariKod: this.val.Rez.cariKod.kod,
        OtelKod: _otelKodValue,
        OperatorKod: this.val.kalem.turOperatoru.kod,
        Pansiyon: this.getFiyatListRequest.Pansiyon,
        OdaTip: this.val.kalem.kalemOtel.odaTipi.kod,
        Konum: _konumValue,
        Ulke: this.getFiyatListRequest.Ulke,
        Sehir: this.getFiyatListRequest.Sehir,
        Yer: this.getFiyatListRequest.Yer,
        SaticiKonumu: this.getFiyatListRequest.SaticiKonumu,
        SiralamaTipi: 4,
        Kategori: this.getFiyatListRequest.Kategori,
        MaxGunSayisi: 7,
        FiyatKodu: _fiyatKodValue,
      };
      tool.http_post(this, "OtelFiyatSec", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.data.length == 0) {
              this.text1 = "Uygun Fiyat Bulunamadı";
              this.snackbar = true;
              this.fiyatBulLoad = false;
            } else {
              this.fiyatItems = response.body.data;

              this.exploded = !this.exploded;
              for (let i = 0; i < this.fiyatItems.length; i++) {
                var pansiyonName = rez.Pansiyon.find(
                  (x) => x.kod === this.fiyatItems[i].Pansiyon
                );
                this.fiyatItems[i].Pansiyon = pansiyonName.aciklama;
                const item = this.fiyatItems[i];
                this.$set(
                  this.$refs.itemsTable.expanded,
                  item.Isim,
                  this.exploded
                );
              }
              this.fiyatBulLoad = false;
            }
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.fiyatBulLoad = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.fiyatBulLoad = false;
        }
      );
    },
    getUlkeItems() {
      if (this.ulkeItems.length == 0) {
        tool.http_post(this, "UlkeList", {}).then(
          (response) => {
            if (response.body.Status == true) {
              this.ulkeItems = response.body.data;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          },
          (response) => {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
          }
        );
      }
    },
    getSehirItems() {
      var params = {
        UlkeId: this.getFiyatListRequest.Ulke,
      };
      tool.http_post(this, "IlList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.sehirItems = response.body.data;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-IlList";
          this.snackbar = true;
        }
      );
    },
    getIlceItems() {
      var params = {
        IlId: this.getFiyatListRequest.Sehir,
      };
      tool.http_post(this, "IlceList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.ilceItems = response.body.data;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-IlList";
          this.snackbar = true;
        }
      );
    },
    getSemtItems() {
      var params = {
        IlceId: this.getFiyatListRequest.Yer,
      };
      tool.http_post(this, "SemtList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.semtItems = response.body.data;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-IlList";
          this.snackbar = true;
        }
      );
    },
    cancel() {
      this.dialogFiyat = false;
    },
    getparabirimi() {
      return helpers.getparabirimiDefault();
    },
    kalemekle() {
      if(this.val.kalem.yet_KisiSayisi == ''){
        this.snackbar = true;
        this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
        return false;
      }

      if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
         let data ={
          response: {},
          request:{},
          api:'kalemSaticiKontrol',
          type:2,
           message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
        };
        this.$refs.showMessage.open(data);
        return false;
      }



      if(this.secilenkayitlar.length == 0 ){
        let data ={
          response: {},
          request:{},
          api:'kalemSaticiKontrol',
          type:2,
         message: "this.$t('Contact-List-cannot-be-empty-Please-add-Person')"
        };
        this.$refs.showMessage.open(data);   
        return false;
      }

      if (this.val.kalem.P_RP == "P") {
      } else {
        // this.val.kalem.yet_Satis = 0;
        this.val.kalem.co1_Satis = 0;
        this.val.kalem.co2_Satis = 0;
        this.val.kalem.co3_Satis = 0;
        this.val.kalem.co4_Satis = 0;
        this.val.kalem.ekY_Satis = 0;
        //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      this.val.kalem.kisiSira = [];
      this.secilenkayitlar.forEach((element) => {
        var a = this.val.Kisiler.indexOf(element);

        if (a != -1) {
          this.val.kalem.kisiSira.push(a);
        }
      });
      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      this.val.kalem.kalemRentACar = null;
      this.val.kalem.kalemVize = null;
      this.val.kalem.kalemAcente = null;
      this.val.kalem.kalemCharter = null;
      this.val.kalem.kalemFeribot = null;
      this.val.kalem.kalemGemi = null;
      this.val.kalem.kalemGolf = null;
      this.val.kalem.kalemMuze = null;
      this.val.kalem.kalemRehber = null;
      this.val.kalem.kalemRestaurant = null;
      this.val.kalem.kalemSigorta = null;
      this.val.Rez.kalemler.push(this.val.kalem);
      this.val.islem = "new";
      this.val.aktif = false;
    },
    kalemguncelle() {
      if(this.val.kalem.yet_KisiSayisi == ''){
        this.snackbar = true;
        this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
        return false;
      }

      if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
         let data ={
          response: {},
          request:{},
          api:'kalemSaticiKontrol',
          type:2,
           message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
        };
        this.$refs.showMessage.open(data);
        return false;
      }

      if(this.secilenkayitlar.length == 0 ){
        let data ={
          response: {},
          request:{},
          api:'kalemSaticiKontrol',
          type:2,
         message: "this.$t('Contact-List-cannot-be-empty-Please-add-Person')"
        };
        this.$refs.showMessage.open(data);  
        
        return false;
      }

      if (this.val.kalem.P_RP == "P") {
      } else {
        this.val.kalem.co1_Satis = 0;
        this.val.kalem.co2_Satis = 0;
        this.val.kalem.co3_Satis = 0;
        this.val.kalem.co4_Satis = 0;
        this.val.kalem.ekY_Satis = 0;
        //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      this.val.kalem.kalemRentACar = null;
      this.val.kalem.kalemVize = null;
      this.val.kalem.kalemAcente = null;
      this.val.kalem.kalemCharter = null;
      this.val.kalem.kalemFeribot = null;
      this.val.kalem.kalemGemi = null;
      this.val.kalem.kalemGolf = null;
      this.val.kalem.kalemMuze = null;
      this.val.kalem.kalemRehber = null;
      this.val.kalem.kalemRestaurant = null;
      this.val.kalem.kalemSigorta = null;
      this.val.kalem.kisiSira = [];

      this.secilenkayitlar.forEach((element) => {
        var a = this.val.Kisiler.indexOf(element);
        if (a != -1) {
          this.val.kalem.kisiSira.push(a);
        }
      });

      this.val.Rez.kalemler.splice(this.val.recordno, 1, this.val.kalem);
      this.val.aktif = false;
      this.val.islem = "new";
    },

    KisiTipToStr(tip) {
      return rez.KisiTipToStr(tip);
    },
    menuClick: menuClick,
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    setSelected(v) {
      this.selected = v;
    },
    setDialogShow(v) {
      this.dialogShow = v;
    },

    close() {
      this.value.dialogShow = false;
      setTimeout(() => {
        this.value.kalem = Object.assign({}, rez.Kalem());

        this.value.editedIndex = -1;
      }, 300);
    },

    modalOk() {
      this.value.kalem.kisiSira = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
      }

      if (this.value.editedIndex > -1) {
        Object.assign(
          this.value.Rez.kalemler[this.value.editedIndex],
          this.value.kalem
        );
      } else {
        this.value.Rez.kalemler.push(this.value.kalem);
      }
      this.close();
    },
  },
};

function menuClick(v) {
  if (v == 0) {
    this.dialogFiyat = true;
    this.getFiyatListRequest.OtelKod = this.val.kalem.satici;

    this.getUlkeItems();
  }

  //HR Beta açılınca kullanılacak
  // if (v == 0) {
  //   window.localStorage.removeItem("hrrezervasyon");

  //   var rezervasyon = {
  //     Rezervasyon: this.value.Rez,
  //     HotelRuner: null,
  //     hrislem: false,
  //   };

  //   window.localStorage.setItem("hrrezervasyon", JSON.stringify(rezervasyon));
  //   var url = "#/hotelrunner/index/id?isl=hrget";
  //   window.open(url, "_self");
  // } else if (v == 1) {
  //   this.dialogFiyat = true;
  //   this.getUlkeItems();
  // }
}
</script>
